var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { SegmentService } from 'ngx-segment-analytics';
import * as Sentry from '@sentry/browser';
import { UserService } from '../user.service';
import { ObjectUtils } from '../../utils/object.utils';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { appVersion } from '../../../environments/environment';
import { PdfExportService } from '../export-pdf/pdf-export.service';
export var UserActionType;
(function (UserActionType) {
    UserActionType["SEARCH"] = "Search";
    UserActionType["CREATE"] = "Create";
    UserActionType["UPDATE"] = "Update";
    UserActionType["LOGIN"] = "Login";
    UserActionType["VIEW"] = "View";
    UserActionType["ACTION"] = "Action";
    UserActionType["SELECTION"] = "Selection";
    UserActionType["DELETE"] = "Delete";
    UserActionType["TOGGLE"] = "Toggle";
    UserActionType["EXPORT"] = "Export";
    UserActionType["FETCH"] = "Fetch";
    UserActionType["SIGN_UP"] = "Sign Up";
    UserActionType["VERIFIED"] = "Verified";
    UserActionType["MESSAGE"] = "Message";
    UserActionType["SUPPORT"] = "Support";
    UserActionType["UPLOAD"] = "Upload";
    UserActionType["CHAM_GROUP_CREATE"] = "Cham Group Created";
    UserActionType["CHAM_CAMPAIGN_CREATE"] = "Cham Created Campaign";
    UserActionType["CHAM_ENABLED_GROUP_DISCOVERY"] = "Cham Enabled Group Discovery";
    UserActionType["CHAM_ACCEPT_CAMPAIGN"] = "Cham Accepted Campaign Influencer";
    UserActionType["CHAM_INVITED_CAMPAIGN_INFLUENCER"] = "Cham Invited Campaign Influencer";
    UserActionType["CHAM_ADD_INFLUENCER_TO_GROUP"] = "Cham Added Influencers";
    UserActionType["CHAM_STARTED_TRIAL"] = "Cham Started Trial";
    UserActionType["ONBOARDING"] = "Onboarding";
    UserActionType["LOAD_DATA_SAMPLES"] = "Load Data Samples";
    UserActionType["CHOSE_DATA_SAMPLE"] = "Chose Data Sample";
    UserActionType["EMAIL_SETTING"] = "Email Settings";
})(UserActionType || (UserActionType = {}));
export var ActionDetails;
(function (ActionDetails) {
    ActionDetails["ADDED_POSTS"] = "Added Posts";
    ActionDetails["ADDED_INFLUENCERS"] = "Added Influencers";
    ActionDetails["REMOVED_INFLUENCERS"] = "Removed Influencers";
    ActionDetails["MOVED_INFLUENCERS"] = "Moved Influencers";
    ActionDetails["UPDATED_DETAILS"] = "Updated Details";
    ActionDetails["ADDED_MENTION"] = "Added Mention";
    ActionDetails["UPDATE_CONFIG"] = "Updated Config";
    ActionDetails["INFLUENCER_OPEN_REQUEST"] = "Open";
    ActionDetails["INFLUENCER_REQUEST_DELETE"] = "Closed";
    ActionDetails["INFLUENCER_ACCEPTED_REQUEST"] = "Accepted";
    ActionDetails["INFLUENCER_REJECTED_REQUEST"] = "Declined";
    ActionDetails["INFLUENCER_CAMPAIGN_ARCHIVED"] = "Archived";
    ActionDetails["CONFIRMED_DETAILS"] = "Confirmed Details";
    ActionDetails["INFLUENCER_INVITE_REQUEST"] = "Invited";
    ActionDetails["INFLUENCER_DECLINED_REQUEST"] = "Declined";
    ActionDetails["INFLUENCER_CONFIRM_CHANNEL"] = "Confirmed Channel";
    ActionDetails["REQUEST_UPGRADE"] = "Request Upgrade";
    ActionDetails["IDENTIFY_RELEVANT_INFLUENCERS_ON"] = "On";
    ActionDetails["IDENTIFY_RELEVANT_INFLUENCERS_OFF"] = "Off";
    ActionDetails["UPDATED_DISCOVERY_FILTERS"] = "Updated Discovery Filters";
    ActionDetails["ADDED_INFLUENCERS_FOR_REVIEW"] = "Added Influencers For Review";
    ActionDetails["BULK_UPLOAD"] = "Bulk Upload";
    ActionDetails["ARCHIVED_CAMPAIGN"] = "Archived Campaign";
    ActionDetails["UNARCHIVED_CAMPAIGN"] = "Unarchived Campaign";
    ActionDetails["HANDLE_SEARCH"] = "Handle Search";
})(ActionDetails || (ActionDetails = {}));
export var Page;
(function (Page) {
    Page["GROUP"] = "Influencer Group";
    Page["CAMPAIGN"] = "Campaign";
    Page["HOME"] = "Home";
    Page["DEMOGRAPHICS"] = "Influencer Demographics";
    Page["MEASURE"] = "Measure";
    Page["DISCOVER"] = "Discover";
    Page["REPORT"] = "Report";
    Page["PROJECT"] = "Project";
    Page["MENTION"] = "Mention";
    Page["SUB_SCRIPTION"] = "Sub Scription";
    Page["HOME_TAB"] = "Home Tab";
    Page["DISCOVER_TAB"] = "Discover Tab";
    Page["INFLUENCER_TAB"] = "Influencer Tab";
    Page["CAMPAIGN_TAB"] = "Campaign Tab";
    Page["MEASURE_TAB"] = "Measure Tab";
    Page["INBOX_TAB"] = "Inbox Tab";
    Page["CHANGE_PASSWORD_MODAL"] = "Change Password Modal";
    Page["SETTING_PAGE"] = "Setting Page";
    Page["BILLING_PAGE"] = "Billing Page";
    Page["NOTIFICATION"] = "Notification";
    Page["LOGIN"] = "Login";
    Page["INFLUENCER_DETAILS"] = "Influencer Details";
    Page["INFLUENCER_OVERVIEW"] = "Influencer Overview";
    Page["INFLUENCER_INSIGHTS"] = "Influencer Insights";
    Page["INFLUENCER_CAMPAIGNS"] = "Influencer Campaigns";
    Page["INFLUENCER"] = "Influencer";
    Page["POST"] = "Post";
    Page["IG_STORY"] = "Instagram Story";
    Page["WALL_NOTIFICATION"] = "Wall Notification";
    Page["CHAT"] = "Chat";
    Page["CAMPAIGN_INVITATION"] = "Campaign Invitation";
    Page["CONTACT_PERMISSION"] = "Contact Permission";
    Page["CHANNEL"] = "Channel";
    Page["ACCOUNT_DETAILS"] = "Account Details";
    Page["CAMPAIGN_DETAILS"] = "Campaign Details";
    Page["INFLUENCER_GROUP"] = "Influencer Group";
    Page["RECENTLY_VIEWED_INFLUENCERS_GROUP"] = "Recently Viewed Influencers";
    Page["PROFILE"] = "Profile";
    Page["IMAGE"] = "Image";
    Page["SETTINGS_PAGE"] = "Account Settings Page";
    Page["CAMPAIGN_SETTING"] = "Campaign Settings";
    Page["EMAIL_SETTING"] = "Email Settings";
})(Page || (Page = {}));
export var ActivePages;
(function (ActivePages) {
    ActivePages["CAMPAIGN_OVERVIEW"] = "Campaign Overview";
    ActivePages["CAMPAIGN_NEW"] = "New Campaign";
    ActivePages["CAMPAIGN_EDIT"] = "Edit Campaign";
    ActivePages["DISCOVER"] = "Discover";
    ActivePages["GROUP_OVERVIEW"] = "Group Overview";
    ActivePages["GROUP_DETAILS"] = "Group Details";
    ActivePages["INFLUENCER_DETAILS"] = "Influencer Details";
    ActivePages["INFLUENCER_OVERVIEW"] = "Influencer Overview";
    ActivePages["INFLUENCER_INSIGHTS"] = "Influencer Insights";
    ActivePages["INFLUENCER_DEMOGRAPHICS"] = "Influencer Demographics";
    ActivePages["INFLUENCER_CAMPAIGNS"] = "Influencer Campaigns";
    ActivePages["LOGIN"] = "Login";
    ActivePages["MENTION"] = "Mention";
    ActivePages["MEASURE"] = "Measure";
    ActivePages["INBOX"] = "Inbox";
    ActivePages["POST"] = "Post Overview";
    ActivePages["CAMPAIGN_HISTORY"] = "Campaign History";
    ActivePages["CAMPAIGN_DETAILS"] = "Campaign Details";
    ActivePages["ACTIVE_CAMPAIGN"] = "Active Campaign";
    ActivePages["ARCHIVED_CAMPAIGN"] = "Archived Campaign";
})(ActivePages || (ActivePages = {}));
export var TargetType;
(function (TargetType) {
    TargetType["INFLUENCER"] = "Influencer";
    TargetType["ADVERTISER"] = "Advertiser";
    TargetType["CAMPAIGN"] = "Campaign";
    TargetType["CAMPAIGN_DETAILS"] = "Campaign Details";
    TargetType["INFLUENCER_GROUP"] = "Influencer Group";
    TargetType["POST"] = "Post";
    TargetType["PROJECT"] = "Project";
    TargetType["FILTER"] = "Filter";
    TargetType["SORT"] = "Sort";
    TargetType["DATE_RANGE"] = "Date Range";
    TargetType["MODULES"] = "Modules";
    TargetType["REPORT"] = "Report";
    TargetType["BUTTON"] = "Button";
    TargetType["BACKDROP"] = "Backdrop";
    TargetType["OPEN_CONTACT_TAB"] = "Open Contact Tab";
    TargetType["ACCOUNT"] = "Account";
    TargetType["CHANNEL"] = "Channel";
    TargetType["REQUEST_REVIEW"] = "Request Review";
    TargetType["USER"] = "User";
    TargetType["PROFILE_IMAGE"] = "Profile Image";
    TargetType["GROUP_DISCOVERY"] = "Group Discovery";
})(TargetType || (TargetType = {}));
// We're adding action_source as a new field to action events, they explain where a user performed a specific action
export var ActionSource;
(function (ActionSource) {
    ActionSource["PAGE"] = "Page";
    ActionSource["MODAL"] = "Modal";
    ActionSource["BOTTOM_BAR"] = "Bottom Bar";
    ActionSource["ACTION_VIEW"] = "Action View";
    ActionSource["CAMPAIGN_LANDING_PAGE"] = "Landing Page";
    ActionSource["INFLUENCER_APP"] = "Influencer App";
    ActionSource["UNDO_LINK"] = "Undo Link";
    ActionSource["COMMUNICATION_PAGE"] = "Communications Page";
    ActionSource["ACTIVITY_TAB"] = "Activity Tab";
    ActionSource["PENDING_LIST"] = "Pending List";
    ActionSource["GROUP_SETTINGS"] = "Group Settings";
})(ActionSource || (ActionSource = {}));
var EventTrackerService = /** @class */ (function () {
    function EventTrackerService(segment, userService, pdfExportService) {
        var _this = this;
        this.segment = segment;
        this.userService = userService;
        this.pdfExportService = pdfExportService;
        this.hasIdentified = new BehaviorSubject(false);
        this.userService.companyId.subscribe(function (activeCompany) {
            if (activeCompany && activeCompany !== _this.authorizedCompanyId) {
                _this.identifyCurrentUserWithSegment(activeCompany, _this.userService.accountType());
            }
        });
        this.userService.accountLevels.subscribe(function (accountLevel) {
            if (accountLevel) {
                _this.updateCompanySubscription(accountLevel.level.name);
                if (!_this.hasIdentified.getValue()) {
                    _this.identifyCurrentUserWithSegment(_this.userService.getCompanyId(), accountLevel.level.name);
                }
            }
        });
        this.preventPdfTracking();
    }
    Object.defineProperty(EventTrackerService.prototype, "isIdentifiedUser", {
        get: function () {
            return this.hasIdentified.getValue();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventTrackerService.prototype, "hasIdentifiedObserver", {
        get: function () {
            return this.hasIdentified.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    EventTrackerService.prototype.identifyCurrentUserWithSegment = function (activeCompany, accountLevel) {
        var user = ObjectUtils.parseJSON(localStorage.getItem('user'));
        if (user) {
            this.identifyUser(user, activeCompany, accountLevel);
        }
    };
    /**
     * This method is used to identify an user when they login to app
     * @param {User} user
     */
    EventTrackerService.prototype.identifyUser = function (user, currentActiveCompanyId, accountLevel, callback) {
        var _this = this;
        var userData = user.data;
        // Fallback if user is undefined
        if (!userData) {
            Sentry.captureException(new Error('Attempted to identify user without userData object'));
            this.hasIdentified.next(false);
            return;
        }
        this.superProperties = Object.assign({}, this.superProperties, {
            // super properties
            user_id: userData.id,
            user_name: userData.fullName,
            user_company_id: userData.company.id,
            user_company_name: userData.company.name,
            company: {
                id: userData.company.id,
                name: userData.company.name // Intercom
            },
            currently_active_company_name: this.userService.getCompanyName(currentActiveCompanyId),
            currently_active_company_id: currentActiveCompanyId,
            user_role: userData.role.name,
            user_creation_date: new Date(userData.createdAt).toISOString(),
            user_company_subscription: accountLevel,
            user_company_account_type: (userData.company.companyType.name.match(/Agency/) ? 'Agency' : userData.company.companyType.name),
            user_company_account_sub_type: userData.company.companyType.name,
            app_version: appVersion,
            has_started_trial: this.userService.getStartedTrialValue,
            is_sso_user: userData.isSsoUser,
            signup_entity: userData.signupEntity,
            signup_source: userData.signupSource
        });
        var params = __assign({ 
            // people properties
            email: userData.email, name: userData.fullName, created: userData.createdAt, createdAt: userData.createdAt, last_login: new Date() }, this.superProperties);
        var custom_settings = {
            Intercom: { hideDefaultLauncher: true }
        };
        // register user
        this.segment.identify(userData.id, params, custom_settings).then(function () {
            _this.authorizedCompanyId = currentActiveCompanyId;
            _this.hasIdentified.next(true);
            if (callback) {
                callback();
            }
        }, function (error) {
            _this.hasIdentified.next(false);
            var userId = userData.id;
            var detailsError = error.toString();
            Sentry.captureException(new Error('An error happen when identify user in segment'));
        });
        this.segment.page();
    };
    /**
     * Track user sign-up
     * @param {User} userInfo
     * @param isInvited
     */
    EventTrackerService.prototype.trackUserSignup = function (userInfo, isInvited) {
        var _this = this;
        this.identifyUser(userInfo, null, null, function () {
            _this.segment.track(UserActionType.SIGN_UP, {
                source: isInvited ? 'Invite' : 'Self-Service'
            }).then(function (res) { }, function (error) {
                var detailsError = error.toString();
                Sentry.captureException(new Error("An error happen while tracking event " + UserActionType.SIGN_UP));
            });
        });
    };
    /**
     * Track when user open the email settings page
     * @param userId
     */
    EventTrackerService.prototype.trackEmailSetting = function (userId) {
        var _this = this;
        var custom_settings = {
            Intercom: { hideDefaultLauncher: true }
        };
        this.segment.identify(userId, { name: userId }, custom_settings).then(function () {
            _this.hasIdentified.next(true);
            _this.segment.track(UserActionType.VIEW, { item: Page.EMAIL_SETTING }).then(function (res) { }, function (error) {
                Sentry.captureException(new Error("An error happen while tracking event " + UserActionType.EMAIL_SETTING));
            });
        }, function (error) {
            _this.hasIdentified.next(false);
            Sentry.captureException(new Error('An error happen when identify user in segment'));
        });
    };
    /**
     * Track whenever user verify their email successfully
     * @param {User} userInfo
     * @param isInvited
     */
    EventTrackerService.prototype.trackUserVerifyAccount = function (userInfo) {
        var _this = this;
        this.identifyUser(userInfo, null, null, function () {
            _this.segment.track(UserActionType.VERIFIED).then(function (res) { }, function (error) {
                var detailsError = error.toString();
                Sentry.captureException(new Error("An error happen while tracking event " + UserActionType.VERIFIED));
            });
        });
    };
    /**
     * A wrapper of Segment event tracker. Use it to track user behaviour
     * @param {UserActionType} action
     * @param {Page} item
     * @param target
     * @param params
     * @param report
     * @param {ActivePage} activePage
     */
    EventTrackerService.prototype.trackUserAction = function (action, item, target, params, report, activePage, extraProperties) {
        // Only allow to track user action when user is identified successfully
        if (!this.isIdentifiedUser) {
            return;
        }
        var properties = this.buildSegmentProperties(action, item, target, params, report, activePage, extraProperties);
        this.segment.track(action, properties).then(function (res) { }, function (error) {
            var detailsError = error.toString();
            Sentry.captureException(new Error('An error happen when tracking user actions'));
        });
    };
    EventTrackerService.prototype.trackUserInvalidAction = function (detailsAction, action, item, target, params, report, activePage, extraProperties) {
        // Only allow to track user action when user is identified successfully
        if (!this.isIdentifiedUser) {
            return;
        }
        var properties = this.buildSegmentProperties(action, item, target, params, report, activePage, extraProperties);
        if (detailsAction.blocked) {
            properties = Object.assign({}, properties, {
                blocked: detailsAction.blocked,
                blocked_reason: detailsAction.blockedReason,
                wall_type: detailsAction.wallType,
                wall_name: detailsAction.wallName
            });
        }
        if (detailsAction.limitEnabled) {
            properties = Object.assign({}, properties, {
                limit_enabled: detailsAction.limitEnabled,
                limit_value: detailsAction.limitValue,
                // for some features, we can only do one thing at a time, so desired value = maxValue + 1
                limit_desired: detailsAction.limitDesired ? detailsAction.limitDesired : detailsAction.limitValue + 1
            });
        }
        properties = Object.assign({}, properties, {
            account_level: this.userService.currentUserLevel ? this.userService.currentUserLevel.name : null
        });
        this.segment.track(action, properties).then(function (res) { }, function (error) {
            var detailsError = error.toString();
            Sentry.captureException(new Error('An error happen when tracking user actions'));
        });
    };
    EventTrackerService.prototype.trackUserRequestUpdate = function () {
        // Only allow to track user action when user is identified successfully
        if (!this.isIdentifiedUser) {
            return;
        }
        var properties = {
            action: ActionDetails.REQUEST_UPGRADE,
            sp: this.superProperties,
        };
        this.segment.track(UserActionType.SUPPORT, properties).then(function (res) { }, function (error) {
            var detailsError = error.toString();
            Sentry.captureException(new Error("An error happen when tracking event Request Upgrade"));
        });
    };
    EventTrackerService.prototype.updateCompanySubscription = function (accountLevel) {
        if (this.superProperties) {
            this.superProperties.user_company_subscription = accountLevel;
        }
    };
    EventTrackerService.prototype.buildSegmentProperties = function (action, item, target, params, report, activePage, extraProperties) {
        var properties = { item: item, app_version: 2 };
        if (target) {
            properties = Object.assign({}, properties, {
                target_id: target.id,
                target_name: target.name,
                target_type: target.type,
                filter_name: target.filterName,
                filter_id: target.filterId
            });
        }
        if (report) {
            properties = Object.assign({}, properties, {
                report_id: report.id,
                report_name: report.name
            });
        }
        if (action === UserActionType.ACTION) {
            properties = Object.assign({}, properties, {
                action: params.action,
                action_source: params.source,
                action_details: params.actionDetails
            });
            if (params.action_status) {
                properties = Object.assign({}, properties, {
                    action_status: params.action_status,
                    action_status_details: params.action_status_details
                });
                delete params.action_status;
                delete params.action_status_details;
            }
            if (params.action_stories_count >= 0) {
                properties = Object.assign({}, properties, {
                    action_stories_count: params.action_stories_count,
                    action_stories_timing: params.action_stories_timing
                });
                delete params.action_stories_count;
                delete params.action_stories_timing;
            }
        }
        // special case handle for campaign invitation
        if (action === UserActionType.VIEW && params && params.actionDetails && params.source) {
            properties = Object.assign({}, properties, {
                action_source: params.source,
                action_details: params.actionDetails
            });
        }
        if (params) {
            delete params.action;
            delete params.source;
            delete params.actionDetails;
            if (Object.keys(params).length !== 0) {
                properties = Object.assign({}, properties, { params: params });
            }
        }
        if (activePage) {
            properties = Object.assign({}, properties, {
                active_page_type: activePage.type,
                active_page_name: activePage.name,
                active_page_id: activePage.id,
            });
        }
        if (extraProperties) {
            properties = Object.assign({}, properties, extraProperties);
        }
        // add super properties
        properties = Object.assign({}, properties, {
            sp: this.superProperties
        });
        return properties;
    };
    EventTrackerService.prototype.preventPdfTracking = function () {
        var _this = this;
        this.segment.addSourceMiddleware(function (_a) {
            var integrations = _a.integrations, payload = _a.payload, next = _a.next;
            if (!_this.pdfExportService.exportingPdf) {
                next(payload);
            }
        });
    };
    return EventTrackerService;
}());
export { EventTrackerService };



// WEBPACK FOOTER //
// ./src/app/services/event-tracker/event-tracker.service.ts.pre-build-optimizer.js